import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        boxShadow:'0 4px 10px 0 rgba(0, 0, 0, 0.1)',
        borderRadius:'4px',
        padding:'3px 10px',
        backgroundColor:'#fff',
        fontSize:"10px",
        color:'#222',
        '&.visited':{
            backgroundColor:'#33F752'
        }
    }
}